const passkey_sign_in = {
    setup_page: {
        title: 'Simplifica tu inicio de sesión',
        subtitle: 'Crea una clave de acceso',
        description: 'Registra tu clave de acceso usando la biometría del dispositivo, llaves de seguridad como YubiKey u otros métodos disponibles.',
    },
    trigger_conditional_ui_failed: 'No se pudo activar el autocompletado con passkey.',
};
export default Object.freeze(passkey_sign_in);
